import { createTheme } from "@mui/material/styles";
import { colors } from "./colors";
import { typography } from "./typography";

export const spacing = {
  xs: "4px",
  sm: "8px",
  md: "12px",
  lg: "16px",
  xl: "24px",
  "2xl": "32px",
  "3xl": "48px",
};

export const radius = {
  xs: "4px",
  sm: "6px",
  md: "8px",
  lg: "12px",
  xl: "16px",
  pill: "999px",
};

export const shadows = {
  border: "0 0 0 1px rgba(191, 197, 206, 0.6)",
  sm: "0 2px 4px rgba(15, 31, 61, 0.10)",
  md: "0 4px 8px rgba(15, 31, 61, 0.10)",
};

export const designSystem = {
  colors,
  typography,
  spacing,
  radius,
  shadows,
};

export const muiTheme = createTheme({
  palette: {
    primary: { main: colors.brand.navy500, light: colors.brand.navy50 },
    secondary: { main: colors.brand.red500, light: colors.brand.red50 },
    success: { main: colors.state.success },
    warning: { main: colors.state.warning },
    error: { main: colors.state.danger },
    info: { main: colors.state.info },
    background: { default: colors.neutral[50], paper: colors.neutral.white },
    text: { primary: colors.neutral[900], secondary: colors.neutral[600] },
    divider: colors.neutral[200],
  },
  typography: {
    fontFamily: typography.fontFamily,
    h1: typography.h1,
    h2: typography.h2,
    h3: typography.h3,
    body1: typography.body,
    body2: typography.bodySm,
    button: { ...typography.button, textTransform: "none" },
    caption: typography.caption,
    overline: typography.overline,
  },
  shape: { borderRadius: 8 },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 36,
          borderRadius: radius.sm,
          boxShadow: "none",
          padding: "8px 16px",
          fontWeight: typography.weight.semibold,
          textTransform: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: radius.lg,
          border: `1px solid ${colors.neutral[200]}`,
          boxShadow: shadows.border,
        },
      },
    },
    MuiTextField: { defaultProps: { size: "small" } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: radius.sm, backgroundColor: colors.neutral.white },
      },
    },
  },
});

export const theme = designSystem;
export default designSystem;
